import { useNavigate } from "react-router-dom";
import { IconArrowNarrowLeft } from "@tabler/icons-react";

interface PrecedentComponentProps {
  onBack?: () => void;
}

const PrecedentComponent = ({ onBack }: PrecedentComponentProps) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <p
      style={{
        margin: "auto",
        marginRight: "1rem",
        lineHeight: "normal",
        cursor: "pointer",
      }}
      onClick={handleBack}
    >
      <IconArrowNarrowLeft />
    </p>
  );
};

export default PrecedentComponent;
